var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5DE5\u4F5C\u65F6\u95F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10\\u65B0\\u95FB\\u52A8\\u6001-\\u8BE6\\u60C5",
    transform: "translate(-464, -1993)",
    fill: "#7D9CC2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(0, 1841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE5\\u4F5C\\u65F6\\u95F4",
    transform: "translate(464, 152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.47697983,0 0,4.47743523 0,10 C0,15.5225648 4.47743523,20 10,20 C15.5225648,20 20,15.5225648 20,10 C20,4.47697983 15.5225648,0 10,0 Z M10.1498247,11.7500418 C9.88888384,11.7500418 9.60562869,11.604771 9.42073865,11.4203364 C9.23675941,11.2359017 9.09968577,10.9439941 9.09968577,10.6835087 L9.09968577,4.16681847 C9.09968577,3.706415 9.55052598,3.33344719 10.0104741,3.33344719 C10.4704222,3.33344719 10.9212624,3.706415 10.9212624,4.16681847 L10.9212624,9.92846516 L14.9997723,9.92846516 C15.4601758,9.92846516 15.8331436,10.37885 15.8331436,10.8392535 C15.8331436,11.299657 15.4597204,11.7500418 14.9997723,11.7500418 L10.1498247,11.7500418 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.38bd4ec24c9cc48aadbb0ad53459a17d.svg";
export { ForwardRef as ReactComponent };